export enum EventNames {
    UserLogin = "user_login",
    UserRegistration = "user_registration",
    UserTransparencyNotification = "user_transparency_notification",
    UserUpdate = "user_update",
    UserLead = "user_lead",
    UserLeadModularHouses = "user_lead_modular_houses",
    UserArticleAttachmentDownload = "user_article_attachment_download"
}
